import React, { createElement } from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';
// Meta Pixel Code
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
// Initialize Meta Pixel
;
(function (f: any, b: Document, e: string, v: string, n?: any, t?: HTMLScriptElement, s?: Element) {
  if (f.fbq) return;
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  t = b.createElement(e) as HTMLScriptElement;
  t.async = true;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode!.insertBefore(t, s);
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
// Initialize both pixels
window.fbq('init', '2932119520311880');
window.fbq('init', '1244095477631809');
window.fbq('track', 'PageView');
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<React.StrictMode data-id="element-173">
    <App data-id="element-174" />
  </React.StrictMode>);